/*
 global alert
*/
[].forEach.call(document.querySelectorAll('.list a'), (a, i) => {
	a.addEventListener('mouseover', () => {
		if (document.querySelector('.holder picture.active')){
			document.querySelector('.holder picture.active').classList.remove('active');	
		}
		document.querySelectorAll('.holder picture')[i].classList.add('active')
	});
});
window.addEventListener('load', () => {

	if (document.body.classList.contains('single-project')){
		
		const related = document.getElementsByClassName('related')[0];
		const main = document.getElementsByClassName('project')[0];
		const ho = document.getElementsByClassName('header')[0].offsetHeight;
		const offset = related.offsetHeight;
		let so = 0;
		let cs = 0;


		let scrolled = false;
		let lastScrollTop = 0;
		const scrollFunc = (e) => {
			let st = window.pageYOffset || document.documentElement.scrollTop;
			if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - so)) {
	      console.log(e, scrolled);

	      if (st > lastScrollTop){
	      	main.style.marginTop = '-' + (offset + ho) + 'px';
	      	document.body.style.paddingBottom = (offset) + 'px';
	      	related.style.marginTop = '-' + (offset) + 'px';
	      	so = ho + 10;
	      	scrolled = true;
	      	lastScrollTop = st <= 0 ? 0 : st;
	      	return;
	      }else{
	      	main.removeAttribute('style');
	      	document.body.removeAttribute('style');
	      	related.removeAttribute('style');
	      	so = 0;
	      	scrolled = true;
	      	lastScrollTop = st <= 0 ? 0 : st;
	      	return;
	      }
	      
	    }
	    
	    
		};
		const mouseFunc = (e) => {
			
			if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight)) {

	      if (e.deltaY > 0){
	      	document.body.style.marginTop = '-' + (offset + ho) + 'px';
	      	related.style.marginTop = '-' + (offset) + 'px';
	      	so = ho + 10;
	      }
	    }
	    if (e.deltaY < 0){
      	document.body.style.marginTop = 0;
      	related.removeAttribute('style');
      	so = 0;

      }

		};
		
		/*if (document.body.offsetHeight <= window.innerHeight){
			window.addEventListener("mousewheel", mouseFunc);
			window.addEventListener("DOMMouseScroll", mouseFunc);
			console.log('wheel');
		}else{
			window.addEventListener("scroll", (e) => {
				setTimeout(() => {
					scrollFunc(e);
				}, 250),
				true
			})
			// window.addEventListener("scroll", setTimeout(
			// 	() => {
			// 		scrollFunc()
			// 	}, 125),
			// 	true
			// );
			// window.addEventListener("gesturechage", setTimeout(() => {scrollFunc()}, 125));
			console.log('scroll');
		}*/
		
	}
});